module.exports = __webpack_public_path__ + "static/laptop-7fa211739c913cbc41a606e47f0d534a.png";